var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('QrcodeStream',{attrs:{"camera":_vm.camera},on:{"decode":_vm.onDecode,"init":_vm.onInit}}),_c('p',{staticClass:"error--text"},[_vm._v(_vm._s(_vm.error))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }